import { BaseEntity } from '../base/base.entity';
import { AppService } from '../main/app.service';
import { BaseService } from '../base/base.service';


export class IDeclaration extends BaseEntity {
    shiftId: string;
    employeeId: string;
    name: string;
    dateTimeFrom: any;
    dateTimeTo: any;
    status: number;
    registrationType: string;
    wageCodeId: string;
    wageCodeCode: string;
    duration: number;
}

export class DeclarationService extends BaseService<IDeclaration> {
 
    constructor(protected Restangular: Restangular.IService, protected AppService: AppService) {
        "ngInject";
        super(Restangular, AppService, 'declaration');
    }

    public confirm(data): ng.IPromise<any> {
        return this.Restangular.all(this.itemName).one('confirm').customPOST(data).then((item) => {
            return item;
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/services/declarations.service.ts